export const borrowerPaidAmountFields = [
  'borrowerPaidAtClosingAmount',
  'borrowerPaidBeforeClosingAmount',
];

// The fee fields a targeted /fee/patch save may carry; a field becomes a Direct patch value only when the user
// touched it on this row and it differs from the loaded fee.
export const FEE_PATCH_KEYS = [
  'borrowerPaidAtClosingAmount',
  'borrowerPaidBeforeClosingAmount',
  'sellerPaidAtClosingAmount',
  'sellerPaidBeforeClosingAmount',
  'paidByOthersAmount',
  'financedAmount',
  'feeProviderId',
];
